<app-header />

<app-sidebar />

<main>

  <router-outlet></router-outlet>

  @if(s_modal().visible) {
    <app-modal></app-modal>
  } 
  @if(s_alert().visible) { 
    <app-alert></app-alert>
  }
  
</main>
<!-- 
@if(s_lock()) {
  <app-lock></app-lock>
}  -->

<a id="btn-action" class="btn-action btn-glass" target="_blank"  
    href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
    (click)="goHaylie('regclick')">
    <img style="width: 25px; margin: 0px; border-radius: 0; padding: 3px;position: relative; top: 1.2px; left: .54px;" 
        src="assets/social/whats-777.png" /></a> 
        
<app-footer />

